(function(){
'use strict';
const node=document.getElementById('crtx-native-cart-config');
if(!node||window.CRTXNativeCartGuard)return;
const config=JSON.parse(node.textContent);
window.CRTXNativeCartGuard=true;
let busy=false,bypass=false,reviewRequired=Boolean(config.needsReview),status=null;
const managed=item=>Number(item.variant_id||item.id)===config.giftVariantId&&item.properties?._crtx_subscription_gift==='focus-welcome-v1';
const needsReview=cart=>cart.items.some(managed)||(String(cart.attributes?.crtx_focus_gift_opt_out||'')!=='1'&&cart.items.some(item=>item.quantity>0&&String(config.qualifyingPlans[item.variant_id||item.id]||'')===String(item.selling_plan_allocation?.selling_plan?.id||'none')));
function markReview(value){reviewRequired=value;document.documentElement.classList.toggle('crtx-gift-review-required',value);}
function handoff(replace=false){window.location[replace?'replace':'assign'](config.reviewUrl);}
async function readCart(){
 const response=await fetch(config.cartUrl,{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store',signal:AbortSignal.timeout(15000)});
 if(!response.ok)throw Error('Cart unavailable');
 const cart=await response.json();
 if(!Array.isArray(cart.items))throw Error('Cart unavailable');
 markReview(needsReview(cart));return cart;
}
function showStatus(show){
 if(!status&&show){status=document.createElement('p');status.id='crtx-native-cart-status';status.setAttribute('role','status');status.textContent=config.checkingText;document.body.append(status);}
 if(status)status.hidden=!show;
}
async function guard(event,resume){
 event.preventDefault();event.stopImmediatePropagation();
 if(busy)return;
 busy=true;showStatus(true);
 try{
  await readCart();
  if(reviewRequired){handoff();return;}
  bypass=true;try{resume();}finally{bypass=false;}
 }catch{handoff();}
 finally{busy=false;showStatus(false);}
}
function checkoutLink(element){
 if(!element||element.tagName!=='A')return false;
 try{const url=new URL(element.href,window.location.href);return url.origin===window.location.origin&&/\/(checkout|checkouts)(\/|$)/.test(url.pathname);}catch{return false;}
}
window.addEventListener('click',event=>{
 if(bypass||event.defaultPrevented||event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
 const button=event.target.closest?.('button,input[type="submit"],a');
 if(!button||button.disabled)return;
 if(button.name==='checkout'||button.matches('[data-checkout],.cart__checkout-button')||checkoutLink(button))guard(event,()=>button.click());
},true);
window.addEventListener('submit',event=>{
 if(bypass||event.defaultPrevented)return;
 const form=event.target,submitter=event.submitter;
 let action;try{action=new URL(form.action,window.location.href).pathname;}catch{return;}
 const checkout=/\/(checkout|checkouts)(\/|$)/.test(action)||(/\/cart\/?$/.test(action)&&(submitter?.name==='checkout'||(!submitter&&form.querySelector('[name="checkout"]'))));
 if(checkout)guard(event,()=>form.requestSubmit(submitter||undefined));
},true);
async function verifyPage(){
 try{await readCart();if(config.cartPage&&reviewRequired)handoff(true);}catch{if(config.cartPage&&reviewRequired)handoff(true);}
}
markReview(reviewRequired);
if(config.cartPage&&reviewRequired)handoff(true);
else if(config.cartPage)verifyPage();
window.addEventListener('pageshow',event=>{if(event.persisted)verifyPage();});
for(const name of ['cart:updated','cart:change','cart:refresh'])document.addEventListener(name,verifyPage);
})();
